<script setup>
import { defineEmits, defineProps } from 'vue';
import iconScore from '@/assets/images/screening/popup/icon-score.png';
import iconResult from '@/assets/images/screening/popup/icon-result.png';
import iconSave from '@/assets/images/screening/popup/icon-save.png';
import iconShare from '@/assets/images/screening/popup/icon-share.png';

defineProps({
	loading: { type: Boolean, default: false },
});

const emit = defineEmits(['later', 'explore']);

const features = [
	{
		icon: iconScore,
		text: 'Chấm điểm trực quan theo từng tiêu chí',
	},
	{
		icon: iconResult,
		text: 'Tự động tính tổng điểm và kết quả',
	},
	{
		icon: iconSave,
		text: 'Lưu kết quả vào hồ sơ học sinh',
	},
	{
		icon: iconShare,
		text: 'Chủ động chia sẻ kết quả với phụ huynh',
	},
];
</script>

<template>
	<div class="feature-popup-layer fixed inset-0 flex items-start justify-center overflow-y-auto px-4 py-10">
		<div class="absolute inset-0 feature-popup__mask"></div>
		<div class="feature-popup">
			<div class="feature-popup__hero">
				<div class="feature-popup__sky"></div>
				<img
					alt=""
					class="feature-popup__doodles"
					src="@/assets/images/screening/popup/doodles.svg"
				/>
				<img
					alt=""
					class="feature-popup__cloud"
					src="@/assets/images/screening/popup/wave.svg"
				/>
				<img
					alt=""
					class="feature-popup__brain"
					src="@/assets/images/screening/popup/mask.svg"
				/>
				<img
					alt=""
					class="feature-popup__clipboard"
					src="@/assets/images/screening/popup/clipboard.svg"
				/>
				<img
					alt=""
					class="feature-popup__person"
					src="@/assets/images/screening/popup/body.svg"
				/>
				<img
					alt=""
					class="feature-popup__figure"
					src="@/assets/images/screening/popup/figure.svg"
				/>
				<img
					alt=""
					class="feature-popup__head"
					src="@/assets/images/screening/popup/head.svg"
				/>
				<img
					alt=""
					class="feature-popup__face"
					src="@/assets/images/screening/popup/face.svg"
				/>
				<img
					alt=""
					class="feature-popup__sun"
					src="@/assets/images/screening/popup/sun.svg"
				/>
				<img
					alt=""
					class="feature-popup__star"
					src="@/assets/images/screening/popup/star.svg"
				/>
				<div class="feature-popup__tag feature-popup__tag--in">
					<img alt="" src="@/assets/images/screening/popup/tag-1.svg" />
					<span>ĐÁNH GIÁ ĐẦU VÀO</span>
				</div>
				<div class="feature-popup__tag feature-popup__tag--cars">
					<img alt="" src="@/assets/images/screening/popup/tag-2.svg" />
					<span>C.A.R.S - THANG ĐG TỰ KỶ</span>
				</div>
			</div>

			<div class="feature-popup__body">
				<h2>
					Chuẩn hóa quy trình sàng lọc &amp;<br />
					đánh giá với thang C.A.R.S
				</h2>
				<p>
					Luca ra mắt thang đánh giá tự kỷ ở trẻ em (C.A.R.S), hỗ trợ
					chuyên viên chấm điểm chính xác, tính kết quả tự động và lưu
					trữ ngay trên Luca Education.
				</p>
				<div class="feature-popup__grid">
					<div
						v-for="item in features"
						:key="item.text"
						class="feature-popup__item"
					>
						<img :src="item.icon" alt="" width="32" height="32" />
						<span>{{ item.text }}</span>
					</div>
				</div>
			</div>

			<div class="feature-popup__footer">
				<button
					class="feature-popup__later"
					:disabled="loading"
					type="button"
					@click="emit('later')"
				>
					Để sau
				</button>
				<button
					class="button-p feature-popup__go"
					:disabled="loading"
					type="button"
					@click="emit('explore')"
				>
					Khám phá ngay!
				</button>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.feature-popup-layer {
	z-index: 1100;
}

.feature-popup__mask {
	background: rgba(107, 114, 128, 0.4);
}

.feature-popup {
	position: relative;
	z-index: 1;
	width: 610px;
	max-width: 100%;
	background: #fff;
	border-radius: 16px;
	overflow: hidden;
	box-shadow: 0 0 1px rgba(12, 26, 75, 0.1),
		0 20px 24px rgba(20, 37, 63, 0.06);
}

.feature-popup__hero {
	position: relative;
	height: 320px;
	background: #fff;
}

.feature-popup__sky {
	position: absolute;
	top: 30px;
	left: 0;
	width: 100%;
	height: 180px;
	background: #ff6400;
	border-radius: 20px 20px 0 0;
}

.feature-popup__doodles {
	position: absolute;
	left: 30px;
	top: 51px;
	width: 545px;
	max-width: calc(100% - 40px);
	height: 192px;
	object-fit: contain;
	pointer-events: none;
}

.feature-popup__cloud,
.feature-popup__brain {
	position: absolute;
	left: 0;
	top: 128px;
	width: 100%;
	height: 214px;
	object-fit: fill;
	pointer-events: none;
}

.feature-popup__clipboard {
	position: absolute;
	left: 24%;
	top: 8px;
	width: 150px;
	height: 180px;
	object-fit: contain;
}

.feature-popup__person {
	position: absolute;
	left: 42%;
	top: 96px;
	width: 180px;
	height: 128px;
	object-fit: contain;
}

.feature-popup__figure {
	position: absolute;
	left: 46%;
	top: 58px;
	width: 140px;
	height: 94px;
	object-fit: contain;
}

.feature-popup__head {
	position: absolute;
	left: 54%;
	top: 42px;
	width: 64px;
	height: 64px;
	object-fit: contain;
}

.feature-popup__face {
	position: absolute;
	left: 52%;
	top: 18px;
	width: 42px;
	height: 48px;
	object-fit: contain;
}

.feature-popup__sun {
	position: absolute;
	right: 18%;
	top: 48px;
	width: 56px;
	height: 56px;
}

.feature-popup__star {
	position: absolute;
	left: 12%;
	top: 108px;
	width: 96px;
	height: 84px;
}

.feature-popup__tag {
	position: absolute;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	font-size: 13px;
	line-height: 1;
	white-space: nowrap;

	img {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
	}

	span {
		position: relative;
	}
}

.feature-popup__tag--in {
	left: 12%;
	top: 198px;
	width: 146px;
	height: 36px;
	transform: rotate(13deg);
}

.feature-popup__tag--cars {
	right: 4%;
	top: 128px;
	width: 190px;
	height: 41px;
	transform: rotate(-3deg);
}

.feature-popup__body {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
	padding: 8px 48px 28px;
	text-align: center;
	color: #1d283a;

	h2 {
		font-size: 33px;
		line-height: 40px;
		font-weight: 600;
		letter-spacing: -0.66px;
	}

	p {
		font-size: 16px;
		line-height: 24px;
	}
}

.feature-popup__grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 24px 32px;
	width: 100%;
	margin-top: 28px;
	text-align: left;
}

.feature-popup__item {
	display: flex;
	align-items: flex-start;
	gap: 12px;
	color: #344256;
	font-size: 16px;
	line-height: 24px;

	img {
		width: 32px;
		height: 32px;
		object-fit: contain;
		flex-shrink: 0;
	}
}

.feature-popup__footer {
	display: flex;
	align-items: center;
	gap: 24px;
	padding: 24px 48px;
	background: #fef6f0;
}

.feature-popup__later,
.feature-popup__go {
	flex: 1;
}

.feature-popup__later {
	padding: 20px 18px;
	color: #65758b;
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
}

.feature-popup__go {
	padding: 20px;
	border-radius: 8px;
	font-size: 16px;
	line-height: 24px;
}

.feature-popup__later:disabled,
.feature-popup__go:disabled {
	opacity: 0.6;
	cursor: default;
}

@media (max-width: 767px) {
	.feature-popup__body {
		padding: 8px 20px 24px;

		h2 {
			font-size: 24px;
			line-height: 32px;
		}
	}

	.feature-popup__footer {
		padding: 20px;
	}

	.feature-popup__grid {
		grid-template-columns: 1fr;
	}
}
</style>
